import CloseIcon from "@mui/icons-material/Close"
import { IconButton, styled } from "@mui/material"
import React from "react"

const ScheduleMeetingDialogCloseIconButton = ({ onClick }: { onClick: () => void }) => (
  <_IconButton onClick={onClick}>
    <CloseIcon />
  </_IconButton>
)

export default ScheduleMeetingDialogCloseIconButton

const _IconButton = styled(IconButton)(({ theme }) => ({
  padding: 0,
  "& > .MuiSvgIcon-root": {
    color: theme.palette.gray.dark,
  },
})) as unknown as typeof IconButton
